import { PlusOutlined } from '@ant-design/icons';
import { Cancel, CancelOutlined, CloseOutlined } from '@mui/icons-material';
import { Select, Tabs, Flex, Form, Input, Button } from 'antd';
import UserAutocomplete from "components/UserAutocomplete";
import { UserAutocompleteRef } from 'components/UserAutocomplete/UserAutocomplete';
import { Invitation } from 'interfaces/invitations';
import { TeamMemberRole, TeamMemberRoleOptions } from "interfaces/teams";
import { User } from 'interfaces/users';
import { set } from 'lodash';
import { useEffect, useRef } from "react";
import { fetchUsersForInvitation } from "slices/invitationsActions";
import { fetchUsers } from "slices/usersActions";
import { useAppDispatch, useAppSelector } from "utilities/hooks";

const SelectTabs = ({
    isLoaded,
    setMembersSelected,
    setInvitationsSelected,
    setCurrentTab,
    excludedMembers,
    shareRecipients,
    setShareRecipients,
    role,
    setRole,
}: {
    isLoaded: boolean;
    setMembersSelected: (value: User[]) => void;
    setInvitationsSelected: (value: Invitation[]) => void;
    setCurrentTab: (value: string) => void;
    excludedMembers?: string[];
    shareRecipients: object[];
    setShareRecipients: (value: object[]) => void;
    role: TeamMemberRole;
    setRole: (value: TeamMemberRole) => void;
}) => {
    const dispatch = useAppDispatch();
    const userAutocompleteRef = useRef<UserAutocompleteRef>(null);
    const loaded = useRef(false);
    const excludedRef = useRef(excludedMembers);

    const {
        loading: teamLoading,
        members: teamMembers,
    } = useAppSelector((state) => state.team);
    const {
        loading: invitationsLoading,
    } = useAppSelector((state) => state.invitations);
    const {
        loading: usersLoading,
    } = useAppSelector((state) => state.users);

    const teamMembersRef = useRef<User[]>(teamMembers || []);

    useEffect(() => {
        loaded.current = isLoaded;
    }, [isLoaded]);

    useEffect(() => {
        excludedRef.current = excludedMembers;
    }, [excludedMembers]);

    useEffect(() => {
        if (teamMembersRef.current.length !== (teamMembers || []).length) {
            userAutocompleteRef.current?.refetch();
        }
        teamMembersRef.current = teamMembers || [];
    }, [teamMembers]);

    // useEffect(() => {

    // }, [shareRecipients])

    const waitForTeamMembers = (): Promise<void> => {
        return new Promise((resolve) => {
            if (loaded.current) {
                resolve();
            } else {
                const interval = setInterval(() => {
                    if (loaded.current) {
                        clearInterval(interval);
                        resolve();
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(interval);
                    resolve();
                }, 5000);
            }
        });
    };

    const onDebounce = (value: string, callback: (value: any) => void) => {
        waitForTeamMembers().then(() => {
            dispatch(fetchUsers({ search: value, excluded: excludedRef.current }))
                .unwrap()
                .then((response: any) => {
                    callback(response.data);
                }).catch(() => { });
        });
    };

    // const onInvitationsDebounce = (value: string, callback: (value: any) => void) => {
    //     dispatch(fetchUsersForInvitation(value))
    //         .unwrap()
    //         .then((response: any) => {
    //             callback(response.data);
    //         }).catch(() => { });
    // };

    const handleRoleChange = (value: string) => {
        setRole(value as TeamMemberRole);
    };

    const roleSelect = <Select
        defaultValue={role}
        onChange={handleRoleChange}
        popupClassName="ant-picker-dropdown"
        style={{ marginLeft: 10 }}
    >
        {TeamMemberRoleOptions.map((option: any) => {
            return <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>;
        })}
    </Select>;

    const items = [
        {
            key: 'members',
            label: 'Add members',
            children: <Flex style={{ padding: '10px 0' }}>
                <UserAutocomplete
                    label="Add people"
                    onDebounce={onDebounce}
                    loading={teamLoading || usersLoading || !loaded.current}
                    onChange={setMembersSelected}
                    ref={userAutocompleteRef}
                />
                { roleSelect }
            </Flex>,
        },
        {
            key: 'invitations',
            label: 'Share by Link',
            children: <div>
                {shareRecipients.map((recipient: any, index: number) => {
                    return (<Flex key={index}>
                        <Form.Item style={{width: '100%', padding: '10px 0' }}>
                            <Input
                                id="contact"
                                placeholder="Send to email or phone number"
                                value={recipient.contact}
                                onChange={(e: any) => {
                                    recipient.contact = e.target.value;
                                    let _shareRecipients = [...shareRecipients];
                                    setShareRecipients(_shareRecipients);
                                }}
                            />
                        </Form.Item>
                        <Button
                            style={{ marginTop: 10, float: 'right' }}
                            type="text"
                            onClick={() => {
                                shareRecipients.splice(shareRecipients.indexOf(recipient), 1);
                                setShareRecipients([...shareRecipients]);
                            }}
                            icon={<CloseOutlined />}
                        ></Button>
                    </Flex>);
                })}
                <Button
                    style={{ marginTop: 10, float: 'right' }}
                    type="text"
                    onClick={() => {
                        setShareRecipients([...shareRecipients, {}]);
                    }}
                    icon={<PlusOutlined />}
                >
                    Add Recipient
                </Button>
            </div>
            // <Form.List name="invitations" initialValue={[{
            //     test: 'est',
            // }]}>
            //     {(invitations) => (
            //         <div>
            //             {invitations.toString() + 'asd '}
            //         {invitations.map((field) => (
            //             <Form.Item>
            //                 <Input
            //                     id="contact"
            //                     placeholder="Send to email or phone number"
            //                     // value={null}
            //                     onChange={(e: any) => {
            //                         console.log(e);
            //                         // setInvitationsSelected(e.target.value)
            //                     }}
            //                 />
            //             </Form.Item>
            //         ))}
            //         </div>
            //     )}
            // </Form.List>,
        },
    ];

    return (
        <Tabs
            defaultActiveKey='members'
            items={items}
            onChange={(tabIndex: string) => {
                setCurrentTab(tabIndex);
                if (tabIndex == 'members') userAutocompleteRef.current?.refetch();
            }}
        />
    )
}

export default SelectTabs;
